import React, { Component } from 'react';
import {
    Box,
    IconButton,
    InputBase,
    Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import UndoIcon from '@mui/icons-material/Undo';

export class DeletableNumericInput extends Component {
    focusInput = () => {
        this.inputRef?.focus();
    };

    render() {
        const {
            value,
            setValue,
            placeholder,
            labelAreaWidth,
            disabled,
            maxLength,
            nullable,
            deleted,
            setDeleted,
            onEndEditing,
            onFocus,
            style,
        } = this.props;

        return (
            <Box
                onClick={this.focusInput}
                sx={{
                    display: 'flex',
                    alignItems: 'stretch',
                    border: '1px solid rgba(211,211,211,0.91)',
                    borderRadius: '6px',
                    overflow: 'hidden',
                    minHeight: 56,
                    width: '100%',
                    ...style,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        px: 2,
                        backgroundColor: '#F3F3F3',
                        borderRight: '1px solid rgba(211,211,211,0.91)',
                        ...(labelAreaWidth != null ? { width: labelAreaWidth } : {}),
                    }}
                >
                    <Typography
                        sx={{
                            textAlign: 'center',
                            fontSize: 14,
                            color: '#676767',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {placeholder}:
                    </Typography>
                </Box>

                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        px: 2,
                    }}
                >
                    <InputBase
                        fullWidth
                        inputRef={(ref) => {
                            this.inputRef = ref;
                        }}
                        value={deleted ? '' : (value?.toString().replace('.', ',') ?? '')}
                        inputProps={{
                            inputMode: 'decimal',
                            maxLength: maxLength ?? undefined,
                        }}
                        onChange={(e) => {
                            const text = e.target.value;

                            if (text?.length === 0) {
                                this.inputRef?.blur();
                                return setValue?.(null);
                            }

                            setValue?.(text);
                        }}
                        onFocus={() => {
                            if (disabled) {
                                onFocus?.();
                                this.inputRef?.blur();
                            }
                        }}
                        onBlur={() => {
                            onEndEditing?.(value);
                        }}
                        sx={{
                            fontSize: 16,
                            fontStyle: 'italic',
                        }}
                    />
                </Box>

                {value != null && (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            px: 1,
                        }}
                    >
                        <IconButton
                            onClick={(e) => {
                                e.stopPropagation();
                                if (nullable) {
                                    setDeleted?.(!deleted);
                                } else {
                                    setValue?.(null);
                                }
                            }}
                            size="small"
                        >
                            {deleted ? <UndoIcon /> : <CloseIcon color="error" />}
                        </IconButton>
                    </Box>
                )}
            </Box>
        );
    }
}

export default DeletableNumericInput;